import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { currencyType } from "custom-prop-types";
import styles from "components/settings/currency-tax-language-settings.scss";
import {
  FormButton,
  renderFormElement,
  renderFormNumberElement,
  renderFormToggleElement
} from "components/common/form-elements";

const StatelessCTLForm = ({
  currencies,
  onSaveCurrencyLocaleTax,
  supportedLocales
}) => (
  <form onSubmit={ (e) => { e.preventDefault(); onSaveCurrencyLocaleTax(); } }>
    <h2>Currency</h2>
    <div className={ styles["input-field"] }>
      { renderFormElement("Account Currency", "currency", "select", mapCurrencies(currencies)) }
    </div>

    <div className={ styles.small }>
      In tables and reports, all documents and bills will be automatically converted to the above currency,
      in addition to displaying the original currency.
      We use historic conversion rates from the &nbsp;
      <a href="http://www.ecb.europa.eu/home/html/index.en.html" rel="noopener noreferrer" target="_blank">
        European Central Bank
      </a>,
      but you are free to modify the rate on per-document basis.
    </div>
    <div className={ styles["input-field"] }>
      { renderFormToggleElement("Default Australian tax categories", "isDefaultCategories") }
    </div>

    <h2>Account Tax Rate (GST)</h2>
    <div className={ styles["input-field"] }>
      { renderFormNumberElement("Tax %", "vat", "0", "100", ".01") }
    </div>

    <h2>Language Settings</h2>
    <div className={ styles["input-field"] }>
      { renderFormElement("Default Account Language", "locale", "select", mapLocales(supportedLocales)) }
    </div>

    <div className={ styles.small }>
      The language you choose is used to determine the date format (mm/dd/yyyy or dd/mm/yyyy)
      &nbsp; on your documents, other documents and exports.
    </div>
    <FormButton text={ "Save Changes" } />
  </form>
);

export const CurrencyTaxLanguageForm = reduxForm({ form: "currencyTaxLanguageForm" })(StatelessCTLForm);

StatelessCTLForm.propTypes = {
  currencies: PropTypes.arrayOf(currencyType).isRequired,
  onSaveCurrencyLocaleTax: PropTypes.func.isRequired,
  supportedLocales: PropTypes.arrayOf(PropTypes.string).isRequired
};

const mapCurrencies = (currencies) => currencies.map(currency => ({ key: currency.code, name: currency.code }));
const mapLocales = (locales) => locales.map(locale => ({ key: locale, name: `English (${localeToCountry(locale)})` }));
const localeToCountry = (locale) => locale.split("-").pop();



// WEBPACK FOOTER //
// ./src/js/components/settings/currency-tax-language-form.jsx